import { useEffect } from "react";

import validate from './GroupMemberWorkflowModalValidation';

import useGroupMemberWorkflowData from "../../../state/groupMemberWorkflow/UseGroupMemberWorkflowData";

import UseForm from "@usas/ui-web/utils/UseForm";
import { DEFAULT_ID } from "@usas/ui-web/utils/Constants";

const STATUS_OPTIONS = [
  { id: DEFAULT_ID, name: '--', hasStepNotes: false },
  { id: 'Approved', name: 'Approved', hasStepNotes: false },
  { id: 'Rejected', name: 'Rejected', hasStepNotes: true },
  { id: 'Revisit', name: 'Revisit', hasStepNotes: true }
];

const INITIAL_FORM_STATE = {
  workflowId: DEFAULT_ID,
  groupMemberName: '',
  currentStatus: '',
  stepStatus: DEFAULT_ID,
  displayStepNotes: false,
  stepNotes: ''
};

const useGroupMemberWorkflowModal = (memberObj, onCloseModal) => {
  const { groupMemberWorkflowState, putGroupMemberStepStatus } = useGroupMemberWorkflowData();
  const { formState, errorState, isDirty, setIsDirty, setFormState, setFormData, updateFormState, handleSubmit
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  const updateStepStatus = (newValue) => {
    const selectedStatus = STATUS_OPTIONS.find((x) => x.id === newValue);

    if (selectedStatus) {
      setFormState({
        ...formState,
        stepStatus: newValue,
        displayStepNotes: selectedStatus.hasStepNotes
      });
      setIsDirty(true);
    }
  }

  useEffect(() => {
    setFormData({
      ...formState,
      workflowId: memberObj?.workflowId,
      groupMemberName: `${memberObj?.firstName} ${memberObj?.lastName}`,
      currentStatus: memberObj?.personOrgGroupQualificationStatus,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberObj]);

  async function onSubmitFormCallback(formState) {
    const groupMemberStatusObj = {
      workflowId: formState.workflowId,
      stepStatus: formState.stepStatus,
      stepNotes: formState.stepNotes
    };

    const putGroupMemberStepStatusResult = await putGroupMemberStepStatus(formState.workflowId, groupMemberStatusObj);

    if (putGroupMemberStepStatusResult) {
      onCloseModal(undefined, true);
    }
  }

  return {
    canSave: isDirty === true,
    isSaving: groupMemberWorkflowState.isObjLoading,
    formState,
    errorState,
    updateFormState,
    updateStepStatus,
    handleSubmit,
    statusOptions: STATUS_OPTIONS
  };
};

export default useGroupMemberWorkflowModal;